import { AGE_RANGE_MAX, AGE_RANGE_MIN, formatAgeRangeDraft } from '../../utils/ageRange';

const MODE_OPTIONS = [
  { value: 'range', label: 'Range' }
];

const AgeRangeField = ({
  label = 'Age Range',
  draft,
  onChange,
  error,
  helperText = 'Use one continuous range within 0-8, like 4-7.',
  required = false,
  disabled = false,
  allowAllAges = false
}) => {
  const modeOptions = allowAllAges
    ? [...MODE_OPTIONS, { value: 'all', label: 'All Ages' }]
    : MODE_OPTIONS;

  const handleFieldChange = (field, value) => {
    onChange({
      ...draft,
      [field]: value === '' ? '' : Number.parseInt(value, 10)
    });
  };

  const handleModeChange = (mode) => {
    if (mode === 'all') {
      onChange({ mode: 'all', minAge: '', maxAge: '' });
      return;
    }

    onChange({
      mode,
      minAge: draft.minAge,
      maxAge: mode === 'open' ? '' : draft.maxAge
    });
  };

  const previewValue = formatAgeRangeDraft(draft, { required, allowAllAges });

  return (
    <div>
      <label className="block text-sm font-medium text-text-primary mb-2">
        {label}{required ? ' *' : ''}
      </label>

      <div className="space-y-3">
        <div className="flex flex-wrap gap-2">
          {modeOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              disabled={disabled}
              onClick={() => handleModeChange(option.value)}
              className={`px-3 py-2 text-sm border rounded-lg transition-colors ${
                draft.mode === option.value
                  ? 'border-primary-300 bg-primary-50 text-primary-700'
                  : 'border-gray-200 text-text-secondary hover:bg-gray-50'
              } disabled:opacity-50`}
            >
              {option.label}
            </button>
          ))}
        </div>

        {draft.mode !== 'all' && (
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-text-secondary mb-1">
                From
              </label>
              <input
                type="number"
                min={AGE_RANGE_MIN}
                max={AGE_RANGE_MAX}
                inputMode="numeric"
                value={draft.minAge}
                onChange={(e) => handleFieldChange('minAge', e.target.value)}
                placeholder="2"
                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-200"
                disabled={disabled}
              />
            </div>

            {draft.mode === 'range' ? (
              <div>
                <label className="block text-xs font-medium text-text-secondary mb-1">
                  To
                </label>
                <input
                  type="number"
                  min={AGE_RANGE_MIN}
                  max={AGE_RANGE_MAX}
                  inputMode="numeric"
                  value={draft.maxAge}
                  onChange={(e) => handleFieldChange('maxAge', e.target.value)}
                  placeholder="7"
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-200"
                  disabled={disabled}
                />
              </div>
            ) : (
              <div>
                <label className="block text-xs font-medium text-text-secondary mb-1">
                  Format
                </label>
                <div className="px-3 py-2 border border-dashed border-gray-200 rounded-lg text-text-secondary bg-gray-50">
                  +
                </div>
              </div>
            )}
          </div>
        )}

        <div className="flex flex-wrap items-center gap-2 text-xs">
          <span className="text-text-secondary">{helperText}</span>
          {previewValue && (
            <span className="px-2 py-1 rounded-full bg-gray-100 text-text-primary">
              Saves as: {previewValue}
            </span>
          )}
        </div>

        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}
      </div>
    </div>
  );
};

export default AgeRangeField;
